<!--
 * @Description: 页面顶部Header组件，供程序框架使用
 * @Author: laoliu,wanqian,shh
 * @Date: 2021-01-17 22:43:52
-->
<template>
  <div class="body">
    <div class="left" >
      <el-image  :class="curInstitution && curInstitution.logoPath ? 'inst-logo bd50' : 'inst-logo'" 
        :src="instLogoPath" :fit="curInstitution && curInstitution.logoPath ? 'cover' : 'contain'"></el-image>
      <span style="margin-right: 8px;">{{title}}</span>
      <span style="font-size: 14px; color: #333333; font-weight: 500;">智慧陪护管理平台</span>
      <span v-show="curInstitution && curInstitution.status == 0" 
        style="color: #E9A338; font-size: 14px; margin-left: 6px; font-weight: 500;">
        <i class="el-icon-warning"  style="font-size: 22px; vertical-align: middle; margin-right: 6px;"></i>
        {{curInstitution ? curInstitution.disableNoteMsg : ''}}
      </span>
    </div>
    <div class="right">
      <el-badge is-dot :hidden="!haveUnReadMessage">
				<img class="img-message" :src="require('@/assets/pageframe/icon-header-message.png')" 
          @click="handleMessageClick" alt="" />
      </el-badge>
      &ensp;<el-divider direction="vertical"/>&ensp;
      <el-image  :class="!curAdmin || !curAdmin.photoPath ? 'icons' : 'icons icon-admin-logo'" style="margin-right: 4px" 
        :src="adminPhotoPath" :fit="!curAdmin || !curAdmin.photoPath ? 'contain' : 'cover'">
      </el-image>
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <span class="name mouse-pointer">{{curAdmin.name}}</span>
          <i class="el-icon-arrow-down el-icon--right mouse-pointer"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-setting" command="settings">设置</el-dropdown-item>
          <el-dropdown-item icon="el-icon-switch-button" command="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <change-password-dialog :visible="showChangePwdDialog" @close-dialog="closeChangePwdDialog"/>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'
import changePwdDialog from "../../personal/components/ChangePwdDialog.vue";
import headBus from './HeadBus.js'

export default {
  name: 'Header',
  components: { 
    'change-password-dialog': changePwdDialog,
  },
  data() {
    return {
      curAdmin : {},
      curInstitution : {},
      showChangePwdDialog: false,
      haveUnReadMessage: false,
      messageTimer: null,
      notifyPromise: Promise.resolve(),//禁止重叠
      title: '星护云',
    };
  },

  computed: {  
      instLogoPath: function () {  
        if (process.env.NODE_ENV == 'sdjk' || process.env.NODE_ENV == 'sdjktest') return require('@/assets/pageframe/icon-header-sdjk-hgcloudlogo.png');
        if (!this.curInstitution) return require('@/assets/pageframe/icon-header-hgcloudlogo.png');
        return !this.curInstitution.logoPath
          ? require('@/assets/pageframe/icon-header-hgcloudlogo.png')
          : this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.curInstitution.logoPath);
      },

      adminPhotoPath: function () {
        if (!this.curAdmin) return require('@/assets/pageframe/icon-header-defalutphoto.png');
        return !this.curAdmin.photoPath
          ? require('@/assets/pageframe/icon-header-defalutphoto.png')
          : this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, this.curAdmin.photoPath);
      },
  },
  
  methods: {
    async initData() {
      await this.queryCurrentAdminInstitution();
      this.watchBus();
      this.listNoReadNotice();
      this.requestHaveUnreadMeaage();
      this.messageTimer = setInterval(() => {
        this.requestHaveUnreadMeaage();
      }, Constant.INTERVAL_MESSAGE);
    },

    queryCurrentAdminInstitution() {
      return new Promise((resolve) => {
        let adminType = sessionStorage.getItem(Constant.SESSION_ADMIN_TYPE);
        if (!adminType) adminType = 'global';

        let url = this.commonUtil.fillUrlArgments(Constant.URL_GET_CURRENT_ADMIN_INSTITUTION, adminType, 'false');
        this.appAxios("GET", url).then(result => {
          if (result != null) {
            this.curAdmin = result.data;
            this.curInstitution = result.data.medicalInst; 
            if (this.curAdmin.firstLogin) this.handleShowChangePasswdAlert();
            resolve();
          }
        })
      })
    },

    //获取未读消息列表数据
    listNoReadNotice() {
      let param= {page: 1, pageSize: 5, readStatus: 0};
      let header = this.encryptionUtil.signatureParams(param,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_PAGE_NOTICES_V22,
        param: param,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null || result.data == null) {
          return
        }
        let showNotify = sessionStorage.getItem('showNoReadNotify');
        if (showNotify) {
          this.showNotify(result.data);
        }
      })
    },

    //未读消息提示
    showNotify(noReadNoticeData) {
      let that = this; //函数作用域问题
      if (noReadNoticeData.length) {
        for(let data of noReadNoticeData) {
          let item = data.title;
          let title = item.match(/【(\S*)】/)[1];
          let message = JSON.parse('{' + item.match(/{(\S*)}/)[1] + '}');
          let endStr = item.split('}')[1];
          that.notifyPromise = that.notifyPromise.then(that.$nextTick).then(()=>{ // 禁止重叠
	          that.$notify({
              title: title,
              message: message.linkText+endStr,
              customClass: 'notify-style',
              onClick() {
                that.$router.push({name: 'noticecenter'})
              }
            });
          })
        }
      }
    },

    requestHaveUnreadMeaage() {
      let param = {readStatus: 0};
      let header = this.encryptionUtil.signatureParams(param,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_LIST_FILTER_NOTICES,
        param: param,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };

      this.vueRequest(requestData).then(result => {
        let haveUnReadMessage = result && result.data && result.data.length ? true : false;
        headBus.$emit('refreshHeaderHaveUnReadMessage', haveUnReadMessage);
      })
    },

		handleMessageClick() {
			this.$router.push({name: 'noticecenter'})
		},

    handleShowChangePasswdAlert() {
      this.$confirm('为了您的账号安全，请先去修改密码！', '提示', {
        confirmButtonText: '修 改',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.showChangePwdDialog = true;
      });
    },

    refreHeader(refresh) {
      if(refresh) this.queryCurrentAdminInstitution();
    },

    closeChangePwdDialog() {
      this.showChangePwdDialog = false;
    },

    handleCommand(command) {
      switch(command) {
        case 'settings':
          this.handleSetting();
          break;
        case 'logout':
          this.handleLogout();
          break;
      }
    },

    handleSetting() {
      this.$router.push({name: 'accountsettings'})
    },
    
    handleLogout() {
      this.$confirm('确认是否退出当前账号?', '账号退出', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.appAxios("POST", Constant.URL_LOGOUT).then(_data => {
          this.curAdmin = {};
          this.curInstitution = {};
  
          let adminType = sessionStorage.getItem(Constant.SESSION_ADMIN_TYPE);
          let identifier = sessionStorage.getItem(Constant.SESSION_IDENTIFIER);
          this.$router.push({
            name: 'login', params: {'adminType': adminType, 'identifier': identifier }
          });
        })
      });
    },

    watchBus() {
      //监听个人中心->账户设置->用户头像更改，然后更新头像
      headBus.$on('refreshHeaderAdminLogo', data => {
        this.refreHeader(data);
      });
      headBus.$on('refreshHeaderHaveUnReadMessage', data => {
        this.haveUnReadMessage = data;
      });
    },
  },

  mounted () {
    this.initData();

    this.$nextTick(() => {
      if (process.env.NODE_ENV == 'sdjk' || process.env.NODE_ENV == 'sdjktest') {
        this.title = '悠心陪护';
      } else {
        this.title = '星护云';
      }
    });
  },

  destroyed() {
    headBus.$off('refreshHeaderAdminLogo');
    headBus.$off('refreshHeaderHaveUnReadMessage');
    if(this.messageTimer) {
      clearInterval(this.messageTimer);
    }
  },
}
</script>

<style>
.notify-style {
  cursor: pointer;
}
</style>

<style scoped>
.body {
  border: 0px solid blue;
}

.left {
  float: left;
  min-height: 60px;
  margin-top: 10px;
  vertical-align: middle;
  font-size: 20px;
  font-weight: 600; 
  color: #333333;
}

.inst-logo {
  margin: 0 10px 0 15px;
  vertical-align: middle;
  width: 24px;
  height: 24px;
}

.bd50 {
  border-radius: 50%;
}

.right {
  float: right;
  margin: 12px 22px 0 0;
  vertical-align: middle;
  font-size: 15px;
  color: #666666;
  border: 0px solid red;
}

.icons {
  margin-top: -2px;
  vertical-align: middle;
  width: 16px;
  height: 16px;
}

.icon-admin-logo {
  border-radius: 8px;
}

.name {
  font-size: 15px;
  font-weight: 500;
  color: #666666;
}

.img-message {
	width: 20px;
	height: 15px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/pageframe/components/Header.vue